export class UpdateShouldFullBackupResourceRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "shouldRunFullBackup",
            "baseName": "shouldRunFullBackup",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "shouldRunCoalesce",
            "baseName": "shouldRunCoalesce",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "shouldRunNonCdcBackup",
            "baseName": "shouldRunNonCdcBackup",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "gwsFilterJson",
            "baseName": "gwsFilterJson",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateShouldFullBackupResourceRequest.attributeTypeMap;
    }
    constructor() {
    }
}
